import {
  firebaseObjectTimestampToDate as _firebaseObjectTimestampToDate,
  firebaseTimestampToDate as _firebaseTimestampToDate,
} from '@griply/services';

export const firebaseTimestampToDate = _firebaseTimestampToDate;

export const firebaseObjectTimestampToDate = _firebaseObjectTimestampToDate;
